import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    // Render a loading indicator while checking auth status
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = String(user.system_role || '').toLowerCase();
  if (requireAdmin && role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
